export class SMSRespondents {
    public respondentIds: string[]
}